// import React, { useState, useRef, useEffect } from "react";
// import { 
//   AppBar, 
//   Toolbar, 
//   Box, 
//   Typography, 
//   alpha, 
//   Button, 
//   IconButton, 
//   Drawer, 
//   List, 
//   ListItem, 
//   ListItemText, 
//   ListItemIcon,
//   Collapse,
//   useTheme,
//   Paper,
//   Divider,
//   Fade,
//   Container
// } from "@mui/material";
// import { Link, useNavigate } from "react-router-dom";
// import logo from "../images/logo.png";
// import {
//   Menu as MenuIcon,
//   ArrowDropDown as ArrowDropDownIcon,
//   Close as CloseIcon,
//   Home as HomeIcon,
//   AttachMoney as PricingIcon,
//   CleaningServices as CleaningIcon,
//   PersonAdd as PersonAddIcon,
//   ContactMail as ContactIcon,
//   ExpandLess,
//   ExpandMore,
//   Dashboard as DashboardIcon,
//   PhotoCamera as PhotoCameraIcon,
//   Message as MessageIcon,
//   Payment as PaymentIcon,
//   Checklist as ChecklistIcon,
//   Warning as WarningIcon,
//   PriceChange as PriceChangeIcon,
// } from "@mui/icons-material";
// import FeaturesMenuContent from "./FeaturesMenuContent";

// const AppToolbar = () => {
//   const theme = useTheme();
//   const navigate = useNavigate();
//   const [drawerOpen, setDrawerOpen] = useState(false);
//   const [isFeaturesMenuOpen, setIsFeaturesMenuOpen] = useState(false);
//   const [mobileFeaturesOpen, setMobileFeaturesOpen] = useState(false);
  
//   // Refs for hover timing
//   const hoverTimeoutRef = useRef(null);
//   const menuTimeoutRef = useRef(null);
//   const featuresButtonRef = useRef(null);
//   const featuresMenuRef = useRef(null);

//   // Cleanup timeouts on unmount
//   useEffect(() => {
//     return () => {
//       if (hoverTimeoutRef.current) clearTimeout(hoverTimeoutRef.current);
//       if (menuTimeoutRef.current) clearTimeout(menuTimeoutRef.current);
//     };
//   }, []);

//   // Open features menu
//   const openFeaturesMenu = () => {
//     if (hoverTimeoutRef.current) clearTimeout(hoverTimeoutRef.current);
//     if (menuTimeoutRef.current) clearTimeout(menuTimeoutRef.current);
//     setIsFeaturesMenuOpen(true);
//   };

//   // Close features menu with delay
//   const closeFeaturesMenu = () => {
//     if (menuTimeoutRef.current) clearTimeout(menuTimeoutRef.current);
//     menuTimeoutRef.current = setTimeout(() => {
//       setIsFeaturesMenuOpen(false);
//     }, 150);
//   };

//   // Cancel close when mouse enters menu
//   const cancelCloseMenu = () => {
//     if (menuTimeoutRef.current) {
//       clearTimeout(menuTimeoutRef.current);
//     }
//   };

//   // Toggle Drawer function
//   const toggleDrawer = (open) => (event) => {
//     if (event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
//       return;
//     }
//     setDrawerOpen(open);
//     if (!open) {
//       setMobileFeaturesOpen(false);
//     }
//   };

//   const handleMenuItemClick = (path) => {
//     navigate(path);
//     setDrawerOpen(false);
//     setMobileFeaturesOpen(false);
//   };

//   const toggleMobileFeatures = () => {
//     setMobileFeaturesOpen(!mobileFeaturesOpen);
//   };

//   // Mobile menu items
//   const mobileMenuItems = [
//     { text: "Home", path: "/", icon: <HomeIcon /> },
//     { text: "Pricing", path: "/pricing", icon: <PricingIcon /> },
//     { text: "For Cleaners", path: "/cleaner", icon: <CleaningIcon /> },
//     { text: "Contact", path: "/contact", icon: <ContactIcon /> },
//   ];

//   // Mobile feature sub-menu items
//   const mobileFeatureItems = [
//     { text: "All Features Overview", path: "/features", icon: <DashboardIcon /> },
//     { text: "Set Your Cleaner's Pay", path: "/features/set-your-price", icon: <PriceChangeIcon /> },
//     { text: "Bring Your Cleaner", path: "/features/bring-your-cleaner", icon: <PersonAddIcon /> },
//     { text: "Smart Scheduling", path: "/features/smart-scheduling", icon: <DashboardIcon /> },
//     { text: "Custom Checklist", path: "/features/custom-checklist", icon: <ChecklistIcon /> },
//     { text: "Photo Verification", path: "/features/photo-verification", icon: <PhotoCameraIcon /> },
//     { text: "Incident Report", path: "/features/incident-report", icon: <WarningIcon /> },
//     { text: "In-App Messaging", path: "/features/in-app-messaging", icon: <MessageIcon /> },
//     { text: "Multi-Property Dashboard", path: "/features/multi-property-dashboard", icon: <DashboardIcon /> },
//     { text: "Flexible Payouts", path: "/features/flexible-payouts", icon: <PaymentIcon /> },
//   ];

//   return (
//     <AppBar
//       position="sticky"
//       sx={{
//         backgroundColor: "#fff",
//         color: "#000",
//         boxShadow: `0 1px 0 ${alpha(theme.palette.divider, 0.1)}`,
//       }}
//       elevation={0}
//     >
//       <Container maxWidth="xl">
//         <Toolbar sx={{ justifyContent: "space-between", px: { xs: 0, sm: 0 } }}>
//           {/* Logo */}
//           <Box
//             component={Link}
//             to="/"
//             sx={{ display: "flex", alignItems: "center", textDecoration: "none", gap: 1 }}
//           >
//             <Box
//               component="img"
//               src={logo}
//               alt="FreshSweeper Logo"
//               sx={{ height: 32, width: "auto" }}
//             />
//             <Typography
//               variant="h6"
//               sx={{
//                 fontWeight: 800,
//                 fontSize: 20,
//                 background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.primary.dark})`,
//                 backgroundClip: "text",
//                 WebkitBackgroundClip: "text",
//                 color: "transparent",
//               }}
//             >
//               Freshsweeper
//             </Typography>
//           </Box>

//           {/* Desktop Navigation - Centered */}
//           <Box sx={{ display: { xs: "none", md: "flex" }, gap: 2, alignItems: "center" }}>
//             <Button 
//               component={Link} 
//               to="/" 
//               sx={{ 
//                 color: theme.palette.text.primary, 
//                 fontWeight: 500, 
//                 fontSize: "0.9rem",
//                 textTransform: "none",
//                 '&:hover': { bgcolor: alpha(theme.palette.primary.main, 0.05) }
//               }}
//             >
//               Home
//             </Button>
            
//             <Button 
//               component={Link} 
//               to="/pricing" 
//               sx={{ 
//                 color: theme.palette.text.primary, 
//                 fontWeight: 500, 
//                 fontSize: "0.9rem",
//                 textTransform: "none",
//                 '&:hover': { bgcolor: alpha(theme.palette.primary.main, 0.05) }
//               }}
//             >
//               Pricing
//             </Button>
            
//             {/* Features Dropdown - Stable Hover */}
//             <Box
//               ref={featuresButtonRef}
//               onMouseEnter={openFeaturesMenu}
//               onMouseLeave={closeFeaturesMenu}
//               sx={{ position: "relative" }}
//             >
//               <Button
//                 endIcon={<ArrowDropDownIcon sx={{ transition: 'transform 0.2s', transform: isFeaturesMenuOpen ? 'rotate(180deg)' : 'none' }} />}
//                 sx={{ 
//                   color: theme.palette.text.primary, 
//                   fontWeight: 500, 
//                   fontSize: "0.9rem",
//                   textTransform: "none",
//                   '&:hover': { bgcolor: alpha(theme.palette.primary.main, 0.05) }
//                 }}
//               >
//                 Features
//               </Button>
//             </Box>
            
//             <Button 
//               component={Link} 
//               to="/cleaner" 
//               sx={{ 
//                 color: theme.palette.text.primary, 
//                 fontWeight: 500, 
//                 fontSize: "0.9rem",
//                 textTransform: "none",
//                 '&:hover': { bgcolor: alpha(theme.palette.primary.main, 0.05) }
//               }}
//             >
//               For Cleaners
//             </Button>
            
//             <Button 
//               variant="contained" 
//               sx={{ 
//                 background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.primary.dark})`,
//                 borderRadius: "30px",
//                 px: 3,
//                 py: 0.8,
//                 fontSize: "0.85rem",
//                 fontWeight: 600,
//                 textTransform: "none",
//                 boxShadow: `0 2px 8px ${alpha(theme.palette.primary.main, 0.3)}`,
//                 '&:hover': {
//                   transform: 'translateY(-1px)',
//                   boxShadow: `0 4px 12px ${alpha(theme.palette.primary.main, 0.4)}`,
//                 },
//                 transition: 'all 0.2s'
//               }}
//             >
//               Get the App
//             </Button>
//           </Box>

//           {/* Mobile Menu Icon */}
//           <IconButton
//             sx={{ display: { xs: "flex", md: "none" } }}
//             onClick={toggleDrawer(true)}
//           >
//             <MenuIcon />
//           </IconButton>
//         </Toolbar>
//       </Container>

//       {/* Features Mega Menu - Desktop */}
//       {isFeaturesMenuOpen && (
//         <Box
//           ref={featuresMenuRef}
//           onMouseEnter={cancelCloseMenu}
//           onMouseLeave={closeFeaturesMenu}
//           sx={{
//             position: "absolute",
//             top: "64px",
//             left: 0,
//             right: 0,
//             zIndex: 1300,
//             display: "flex",
//             justifyContent: "center",
//             pointerEvents: "auto",
//           }}
//         >
//           <Fade in={isFeaturesMenuOpen} timeout={200}>
//             <Paper
//               elevation={8}
//               sx={{
//                 mt: 1,
//                 borderRadius: 3,
//                 overflow: "hidden",
//                 border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
//                 boxShadow: "0 20px 40px rgba(0,0,0,0.15)",
//                 width: "auto",
//                 minWidth: 800,
//                 maxWidth: "90vw",
//               }}
//             >
//               <FeaturesMenuContent onItemClick={(path) => navigate(path)} onClose={() => setIsFeaturesMenuOpen(false)} />
//             </Paper>
//           </Fade>
//         </Box>
//       )}

//       {/* Mobile Drawer */}
//       <Drawer anchor="right" open={drawerOpen} onClose={toggleDrawer(false)}>
//         <Box sx={{ width: 300, p: 2 }}>
//           <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
//             <Typography variant="h6" fontWeight="800" sx={{ background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.primary.dark})`, backgroundClip: "text", WebkitBackgroundClip: "text", color: "transparent" }}>
//               Menu
//             </Typography>
//             <IconButton onClick={toggleDrawer(false)}>
//               <CloseIcon />
//             </IconButton>
//           </Box>
          
//           <Divider sx={{ mb: 2 }} />
          
//           <List component="nav">
//             {/* Main Menu Items */}
//             {mobileMenuItems.map((item) => (
//               <ListItem 
//                 button 
//                 key={item.text}
//                 onClick={() => handleMenuItemClick(item.path)}
//                 sx={{ borderRadius: 2, mb: 0.5 }}
//               >
//                 <ListItemIcon sx={{ minWidth: 40, color: theme.palette.primary.main }}>
//                   {item.icon}
//                 </ListItemIcon>
//                 <ListItemText 
//                   primary={item.text} 
//                   primaryTypographyProps={{ fontWeight: 500 }}
//                 />
//               </ListItem>
//             ))}

//             {/* Features with Submenu */}
//             <ListItem 
//               button 
//               onClick={toggleMobileFeatures}
//               sx={{ borderRadius: 2, mb: 0.5 }}
//             >
//               <ListItemIcon sx={{ minWidth: 40, color: theme.palette.primary.main }}>
//                 <DashboardIcon />
//               </ListItemIcon>
//               <ListItemText 
//                 primary="Features" 
//                 primaryTypographyProps={{ fontWeight: 500 }}
//               />
//               {mobileFeaturesOpen ? <ExpandLess /> : <ExpandMore />}
//             </ListItem>
            
//             <Collapse in={mobileFeaturesOpen} timeout="auto" unmountOnExit>
//               <List component="div" disablePadding>
//                 {mobileFeatureItems.map((item) => (
//                   <ListItem 
//                     button 
//                     key={item.text}
//                     onClick={() => handleMenuItemClick(item.path)}
//                     sx={{ pl: 4, borderRadius: 2, mb: 0.5 }}
//                   >
//                     <ListItemIcon sx={{ minWidth: 36, color: theme.palette.text.secondary }}>
//                       {item.icon}
//                     </ListItemIcon>
//                     <ListItemText 
//                       primary={item.text} 
//                       primaryTypographyProps={{ variant: "body2" }}
//                     />
//                   </ListItem>
//                 ))}
//               </List>
//             </Collapse>

//             <Divider sx={{ my: 2 }} />

//             {/* CTA Button in Mobile Menu */}
//             <ListItem 
//               button 
//               onClick={() => handleMenuItemClick("/contact")}
//               sx={{ 
//                 borderRadius: 2, 
//                 bgcolor: alpha(theme.palette.primary.main, 0.1),
//                 '&:hover': { bgcolor: alpha(theme.palette.primary.main, 0.15) }
//               }}
//             >
//               <ListItemIcon sx={{ minWidth: 40, color: theme.palette.primary.main }}>
//                 <PersonAddIcon />
//               </ListItemIcon>
//               <ListItemText 
//                 primary="Get the App" 
//                 primaryTypographyProps={{ fontWeight: 700, color: theme.palette.primary.main }}
//               />
//             </ListItem>
//           </List>
//         </Box>
//       </Drawer>
//     </AppBar>
//   );
// };

// export default AppToolbar;




import React, { useState, useRef, useEffect } from "react";
import { 
  AppBar, 
  Toolbar, 
  Box, 
  Typography, 
  alpha, 
  Button, 
  IconButton, 
  Drawer, 
  List, 
  ListItem, 
  ListItemText, 
  ListItemIcon,
  Collapse,
  useTheme,
  Paper,
  Divider,
  Fade,
  Container,
  ClickAwayListener
} from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import logo from "../images/logo.png";
import {
  Menu as MenuIcon,
  ArrowDropDown as ArrowDropDownIcon,
  Close as CloseIcon,
  Home as HomeIcon,
  AttachMoney as PricingIcon,
  CleaningServices as CleaningIcon,
  PersonAdd as PersonAddIcon,
  ContactMail as ContactIcon,
  ExpandLess,
  ExpandMore,
  Dashboard as DashboardIcon,
  PhotoCamera as PhotoCameraIcon,
  Message as MessageIcon,
  Payment as PaymentIcon,
  Checklist as ChecklistIcon,
  Warning as WarningIcon,
  PriceChange as PriceChangeIcon,
} from "@mui/icons-material";
import FeaturesMenuContent from "./FeaturesMenuContent";

const AppToolbar = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [isFeaturesMenuOpen, setIsFeaturesMenuOpen] = useState(false);
  const [mobileFeaturesOpen, setMobileFeaturesOpen] = useState(false);
  
  // Refs for hover timing
  const hoverTimeoutRef = useRef(null);
  const menuTimeoutRef = useRef(null);
  const featuresButtonRef = useRef(null);
  const featuresMenuRef = useRef(null);

  // Cleanup timeouts on unmount
  useEffect(() => {
    return () => {
      if (hoverTimeoutRef.current) clearTimeout(hoverTimeoutRef.current);
      if (menuTimeoutRef.current) clearTimeout(menuTimeoutRef.current);
    };
  }, []);

  // Open features menu
  const openFeaturesMenu = () => {
    if (hoverTimeoutRef.current) clearTimeout(hoverTimeoutRef.current);
    if (menuTimeoutRef.current) clearTimeout(menuTimeoutRef.current);
    setIsFeaturesMenuOpen(true);
  };

  // Close features menu immediately (no delay for click away)
  const closeFeaturesMenuImmediately = () => {
    if (menuTimeoutRef.current) clearTimeout(menuTimeoutRef.current);
    setIsFeaturesMenuOpen(false);
  };

  // Close features menu with delay (for mouse leave)
  const closeFeaturesMenuWithDelay = () => {
    if (menuTimeoutRef.current) clearTimeout(menuTimeoutRef.current);
    menuTimeoutRef.current = setTimeout(() => {
      setIsFeaturesMenuOpen(false);
    }, 150);
  };

  // Cancel close when mouse enters menu
  const cancelCloseMenu = () => {
    if (menuTimeoutRef.current) {
      clearTimeout(menuTimeoutRef.current);
    }
  };

  // Handle item click - closes menu and navigates
  const handleFeatureItemClick = (path) => {
    setIsFeaturesMenuOpen(false);
    navigate(path);
  };

  // Toggle Drawer function
  const toggleDrawer = (open) => (event) => {
    if (event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
      return;
    }
    setDrawerOpen(open);
    if (!open) {
      setMobileFeaturesOpen(false);
    }
  };

  const handleMenuItemClick = (path) => {
    navigate(path);
    setDrawerOpen(false);
    setMobileFeaturesOpen(false);
  };

  const toggleMobileFeatures = () => {
    setMobileFeaturesOpen(!mobileFeaturesOpen);
  };

  // Mobile menu items
  const mobileMenuItems = [
    { text: "Home", path: "/", icon: <HomeIcon /> },
    { text: "Pricing", path: "/pricing", icon: <PricingIcon /> },
    { text: "For Cleaners", path: "/cleaner", icon: <CleaningIcon /> },
    { text: "Contact", path: "/contact", icon: <ContactIcon /> },
  ];

  // Mobile feature sub-menu items
  const mobileFeatureItems = [
    { text: "All Features Overview", path: "/features", icon: <DashboardIcon /> },
    { text: "Set Your Cleaner's Pay", path: "/features/set-your-price", icon: <PriceChangeIcon /> },
    { text: "Bring Your Cleaner", path: "/features/bring-your-cleaner", icon: <PersonAddIcon /> },
    { text: "Smart Scheduling", path: "/features/smart-scheduling", icon: <DashboardIcon /> },
    { text: "Custom Checklist", path: "/features/custom-checklist", icon: <ChecklistIcon /> },
    { text: "Photo Verification", path: "/features/photo-verification", icon: <PhotoCameraIcon /> },
    { text: "Incident Report", path: "/features/incident-report", icon: <WarningIcon /> },
    { text: "In-App Messaging", path: "/features/in-app-messaging", icon: <MessageIcon /> },
    { text: "Multi-Property Dashboard", path: "/features/multi-property-dashboard", icon: <DashboardIcon /> },
    { text: "Flexible Payouts", path: "/features/flexible-payouts", icon: <PaymentIcon /> },
  ];

  return (
    <AppBar
      position="sticky"
      sx={{
        backgroundColor: "#fff",
        color: "#000",
        boxShadow: `0 1px 0 ${alpha(theme.palette.divider, 0.1)}`,
      }}
      elevation={0}
    >
      <Container maxWidth="xl">
        <Toolbar sx={{ justifyContent: "space-between", px: { xs: 0, sm: 0 } }}>
          {/* Logo */}
          <Box
            component={Link}
            to="/"
            sx={{ display: "flex", alignItems: "center", textDecoration: "none", gap: 1 }}
          >
            <Box
              component="img"
              src={logo}
              alt="FreshSweeper Logo"
              sx={{ height: 32, width: "auto" }}
            />
            <Typography
              variant="h6"
              sx={{
                fontWeight: 800,
                fontSize: 20,
                background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.primary.dark})`,
                backgroundClip: "text",
                WebkitBackgroundClip: "text",
                color: "transparent",
              }}
            >
              Freshsweeper
            </Typography>
          </Box>

          {/* Desktop Navigation - Centered */}
          <Box sx={{ display: { xs: "none", md: "flex" }, gap: 2, alignItems: "center" }}>
            <Button 
              component={Link} 
              to="/" 
              sx={{ 
                color: theme.palette.text.primary, 
                fontWeight: 500, 
                fontSize: "0.9rem",
                textTransform: "none",
                '&:hover': { bgcolor: alpha(theme.palette.primary.main, 0.05) }
              }}
            >
              Home
            </Button>
            
            <Button 
              component={Link} 
              to="/pricing" 
              sx={{ 
                color: theme.palette.text.primary, 
                fontWeight: 500, 
                fontSize: "0.9rem",
                textTransform: "none",
                '&:hover': { bgcolor: alpha(theme.palette.primary.main, 0.05) }
              }}
            >
              Pricing
            </Button>
            
            {/* Features Dropdown - Stable Hover */}
            <Box
              ref={featuresButtonRef}
              onMouseEnter={openFeaturesMenu}
              onMouseLeave={closeFeaturesMenuWithDelay}
              sx={{ position: "relative" }}
            >
              <Button
                endIcon={<ArrowDropDownIcon sx={{ transition: 'transform 0.2s', transform: isFeaturesMenuOpen ? 'rotate(180deg)' : 'none' }} />}
                sx={{ 
                  color: theme.palette.text.primary, 
                  fontWeight: 500, 
                  fontSize: "0.9rem",
                  textTransform: "none",
                  '&:hover': { bgcolor: alpha(theme.palette.primary.main, 0.05) }
                }}
              >
                Features
              </Button>
            </Box>
            
            <Button 
              component={Link} 
              to="/cleaner" 
              sx={{ 
                color: theme.palette.text.primary, 
                fontWeight: 500, 
                fontSize: "0.9rem",
                textTransform: "none",
                '&:hover': { bgcolor: alpha(theme.palette.primary.main, 0.05) }
              }}
            >
              For Cleaners
            </Button>
            
            <Button 
              variant="contained" 
              sx={{ 
                background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.primary.dark})`,
                borderRadius: "30px",
                px: 3,
                py: 0.8,
                fontSize: "0.85rem",
                fontWeight: 600,
                textTransform: "none",
                boxShadow: `0 2px 8px ${alpha(theme.palette.primary.main, 0.3)}`,
                '&:hover': {
                  transform: 'translateY(-1px)',
                  boxShadow: `0 4px 12px ${alpha(theme.palette.primary.main, 0.4)}`,
                },
                transition: 'all 0.2s'
              }}
            >
              Get the App
            </Button>
          </Box>

          {/* Mobile Menu Icon */}
          <IconButton
            sx={{ display: { xs: "flex", md: "none" } }}
            onClick={toggleDrawer(true)}
          >
            <MenuIcon />
          </IconButton>
        </Toolbar>
      </Container>

      {/* Features Mega Menu - Desktop */}
      {isFeaturesMenuOpen && (
        <Box
          ref={featuresMenuRef}
          onMouseEnter={cancelCloseMenu}
          onMouseLeave={closeFeaturesMenuWithDelay}
          sx={{
            position: "absolute",
            top: "64px",
            left: 0,
            right: 0,
            zIndex: 1300,
            display: "flex",
            justifyContent: "center",
            pointerEvents: "auto",
          }}
        >
          <Fade in={isFeaturesMenuOpen} timeout={200}>
            <Paper
              elevation={8}
              sx={{
                mt: 1,
                borderRadius: 3,
                overflow: "hidden",
                border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
                boxShadow: "0 20px 40px rgba(0,0,0,0.15)",
                width: "auto",
                minWidth: 800,
                maxWidth: "90vw",
              }}
            >
              <FeaturesMenuContent 
                onItemClick={handleFeatureItemClick} 
                onClose={closeFeaturesMenuImmediately} 
              />
            </Paper>
          </Fade>
        </Box>
      )}

      {/* Mobile Drawer */}
      <Drawer anchor="right" open={drawerOpen} onClose={toggleDrawer(false)}>
        <Box sx={{ width: 300, p: 2 }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
            <Typography variant="h6" fontWeight="800" sx={{ background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.primary.dark})`, backgroundClip: "text", WebkitBackgroundClip: "text", color: "transparent" }}>
              Menu
            </Typography>
            <IconButton onClick={toggleDrawer(false)}>
              <CloseIcon />
            </IconButton>
          </Box>
          
          <Divider sx={{ mb: 2 }} />
          
          <List component="nav">
            {/* Main Menu Items */}
            {mobileMenuItems.map((item) => (
              <ListItem 
                button 
                key={item.text}
                onClick={() => handleMenuItemClick(item.path)}
                sx={{ borderRadius: 2, mb: 0.5 }}
              >
                <ListItemIcon sx={{ minWidth: 40, color: theme.palette.primary.main }}>
                  {item.icon}
                </ListItemIcon>
                <ListItemText 
                  primary={item.text} 
                  primaryTypographyProps={{ fontWeight: 500 }}
                />
              </ListItem>
            ))}

            {/* Features with Submenu */}
            <ListItem 
              button 
              onClick={toggleMobileFeatures}
              sx={{ borderRadius: 2, mb: 0.5 }}
            >
              <ListItemIcon sx={{ minWidth: 40, color: theme.palette.primary.main }}>
                <DashboardIcon />
              </ListItemIcon>
              <ListItemText 
                primary="Features" 
                primaryTypographyProps={{ fontWeight: 500 }}
              />
              {mobileFeaturesOpen ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            
            <Collapse in={mobileFeaturesOpen} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                {mobileFeatureItems.map((item) => (
                  <ListItem 
                    button 
                    key={item.text}
                    onClick={() => handleMenuItemClick(item.path)}
                    sx={{ pl: 4, borderRadius: 2, mb: 0.5 }}
                  >
                    <ListItemIcon sx={{ minWidth: 36, color: theme.palette.text.secondary }}>
                      {item.icon}
                    </ListItemIcon>
                    <ListItemText 
                      primary={item.text} 
                      primaryTypographyProps={{ variant: "body2" }}
                    />
                  </ListItem>
                ))}
              </List>
            </Collapse>

            <Divider sx={{ my: 2 }} />

            {/* CTA Button in Mobile Menu */}
            <ListItem 
              button 
              onClick={() => handleMenuItemClick("/contact")}
              sx={{ 
                borderRadius: 2, 
                bgcolor: alpha(theme.palette.primary.main, 0.1),
                '&:hover': { bgcolor: alpha(theme.palette.primary.main, 0.15) }
              }}
            >
              <ListItemIcon sx={{ minWidth: 40, color: theme.palette.primary.main }}>
                <PersonAddIcon />
              </ListItemIcon>
              <ListItemText 
                primary="Get the App" 
                primaryTypographyProps={{ fontWeight: 700, color: theme.palette.primary.main }}
              />
            </ListItem>
          </List>
        </Box>
      </Drawer>
    </AppBar>
  );
};

export default AppToolbar;




